import { render, staticRenderFns } from "./totaldetail.vue?vue&type=template&id=7ab23530&scoped=true&"
import script from "./totaldetail.vue?vue&type=script&lang=js&"
export * from "./totaldetail.vue?vue&type=script&lang=js&"
import style0 from "./totaldetail.vue?vue&type=style&index=0&id=7ab23530&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab23530",
  null
  
)

export default component.exports